import { useScreenSize } from '@hooks';
import { bool, func, shape, string } from 'prop-types';
import React from 'react';
import i18n from 'src/i18n';

import { useOfflineImage } from '../../hooks/useOfflineImage';
import { Bold, getContinueButtonText } from './ModuleArticleCard.layoutProps';

const { Button, Flex, Typography, theme } = require('@styles');

const ModuleArticleCard = ({
  data,
  isNext,
  isPrevious,
  onClick,
  onClickBack,
}) => {
  const imageSrc = useOfflineImage(data.image);
  const { dynamicWidth, isTabletLG, isTabletSM } = useScreenSize();

  return (
    <Flex
      backgroundImage={imageSrc || data.image}
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      flexDirection="column"
      height={isTabletLG ? 378 : 478}
      justifyContent="space-between"
      width="100%"
    >
      <Flex>
        <Flex backgroundColor="rgb(1,1,1,0.6)" position="relative">
          <Flex
            backgroundColor={theme.colors.white[100]}
            height="100%"
            opacity="0.06"
            position="absolute"
            width="100%"
          />
          <Typography
            color={theme.colors.white[100]}
            padding={16}
            variant="MS-regular-s18-lh22"
          >
            {data.topText}
          </Typography>
        </Flex>
      </Flex>
      <Flex position="relative">
        <Flex
          backgroundColor={theme.colors.white[20]}
          height="100%"
          pointer
          position="absolute"
          width="100%"
        />
        <Flex
          backgroundColor="rgb(1,1,1,0.6)"
          justifyContent="space-between"
          width="100%"
        >
          {isPrevious && (
            <Flex
              as={Button}
              borderRadius={0}
              height="100%"
              minWidth={isTabletLG ? 0 : '115px'}
              onClick={onClickBack}
              position="relative"
              variant="primary"
              width={isTabletLG ? '20%' : 'auto'}
            >
              <Typography
                color={theme.colors.black[100]}
                variant="MS-semibold-s14-lh15"
              >
                {isTabletSM ? '<<' : i18n.t('Activities.Back').toUpperCase()}
              </Typography>
            </Flex>
          )}
          <Flex maxWidth="60%" p={16} width="60%">
            <Typography
              color={theme.colors.white[100]}
              variant="MS-regular-s18-lh22"
            >
              <Bold>{data.speaker}:</Bold> {data.text}
            </Typography>
          </Flex>
          <Flex
            as={Button}
            borderRadius={0}
            height="100%"
            minWidth={isTabletLG ? 0 : '115px'}
            onClick={onClick}
            position="relative"
            variant="primary"
            width={isTabletSM ? '20%' : 'auto'}
          >
            <Typography
              color={theme.colors.black[100]}
              textTransform="uppercase"
              variant="MS-semibold-s14-lh15"
            >
              {i18n.t(
                isNext
                  ? 'Activities.Next'
                  : getContinueButtonText({ dynamicWidth })
              )}
            </Typography>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

ModuleArticleCard.propTypes = {
  data: shape({
    image: string,
    speaker: string,
    text: string,
    topText: string,
  }).isRequired,
  isNext: bool,
  isPrevious: bool,
  onClick: func.isRequired,
  onClickBack: func.isRequired,
};

ModuleArticleCard.defaultProps = {
  isNext: false,
  isPrevious: false,
};

export default ModuleArticleCard;
